module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_j_erythristic.34181f7c.png";